import {
  PriceRegionName,
  PriceRegionWithPrice,
  PricingItem,
  regionsByPricingRegionName,
} from "../constants/regionsByPricingRegionName";
import {RegionSlug} from "../store/types";

const getDefaultPrices = (allPrices: PriceRegionWithPrice[]): PricingItem[] =>
  allPrices.find(region => region.name === "Northern California")?.prices || [];

// Get pricing region by pricing region name
const getRegionByPriceRegionName = (
  allPrices: PriceRegionWithPrice[],
  priceRegionName: PriceRegionName,
): PricingItem[] => allPrices.find(region => region.name === priceRegionName)?.prices || [];

// Get prices by clinic region slug
export const getPricesByRegionSlug = (
  allPrices: PriceRegionWithPrice[],
  regionSlug: RegionSlug,
): PricingItem[] => {
  if (!regionSlug) return getDefaultPrices(allPrices);

  const pricingPair = Object.entries(regionsByPricingRegionName).find(([, value]) =>
    value.includes(regionSlug),
  );

  if (!pricingPair) return getDefaultPrices(allPrices);

  const priceRegionName = pricingPair[0] as PriceRegionName;

  return getRegionByPriceRegionName(allPrices, priceRegionName);
};
